import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import {
  Backdrop,
  Box,
  Button,
  CircularProgress,
  Dialog,
  Fade,
  Stack,
  Typography,
} from "@mui/material";

export default function CancelProductionDialog({
  open,
  production,
  loading = false,
  error = "",
  onClose,
  onConfirm,
}) {
  function handleClose() {
    if (!loading) onClose?.();
  }

  return (
    <Dialog
      open={Boolean(open)}
      onClose={loading ? undefined : handleClose}
      closeAfterTransition
      slots={{ backdrop: Backdrop }}
      PaperProps={{
        sx: {
          bgcolor: "transparent",
          boxShadow: "none",
          borderRadius: "30px",
          overflow: "visible",
        },
      }}
      slotProps={{
        backdrop: {
          timeout: 180,
          sx: {
            bgcolor: "rgba(2, 8, 23, 0.45)",
            backdropFilter: "blur(3px)",
          },
        },
      }}
    >
      <Fade in={Boolean(open)} timeout={180}>
        <Box
          sx={{
            width: "min(92vw, 560px)",
            bgcolor: "neutral.500",
            borderRadius: "32px",
            p: { xs: 2.5, sm: 3.5 },
            boxShadow: "0px 20px 60px rgba(0,0,0,.28)",
          }}
        >
          <Stack spacing={2.5} sx={{ alignItems: "center" }}>
            <Box
              sx={{
                px: 3,
                py: 1.2,
                bgcolor: "secondary.50",
                borderRadius: "33px",
                boxShadow: "inset 0px 0px 3px rgba(142, 142, 159, 0.5)",
              }}
            >
              <Typography
                sx={{ color: "primary.900", fontSize: 19, fontWeight: 800 }}
              >
                Anular producción
              </Typography>
            </Box>

            <Box
              sx={{
                width: "100%",
                p: { xs: 2.25, sm: 2.75 },
                borderRadius: "22px",
                bgcolor: "neutral.50",
                boxShadow: "inset 0px 0px 2px rgba(96, 96, 113, 0.5)",
              }}
            >
              <Typography
                sx={{
                  fontSize: 17,
                  fontWeight: 700,
                  color: "primary.900",
                  overflowWrap: "anywhere",
                }}
              >
                ¿Querés anular la producción de “{production?.preparedProduct?.name}”?
              </Typography>
              <Typography
                sx={{
                  mt: 0.8,
                  fontSize: 13,
                  fontWeight: 700,
                  color: "neutral.700",
                }}
              >
                Se revertirán los movimientos de stock asociados. Esta acción no
                puede deshacerse.
              </Typography>
              {error ? (
                <Box
                  role="alert"
                  sx={{
                    mt: 2,
                    px: 1.5,
                    py: 1.1,
                    borderRadius: "14px",
                    bgcolor: "secondary.700",
                  }}
                >
                  <Typography
                    sx={{ color: "logoblanco", fontSize: 12, fontWeight: 700 }}
                  >
                    {error}
                  </Typography>
                </Box>
              ) : null}
            </Box>

            <Stack
              direction="row"
              spacing={1.5}
              sx={{ width: "100%", justifyContent: "flex-end" }}
            >
              <Button
                type="button"
                disabled={loading}
                onClick={handleClose}
                variant="contained"
                sx={{
                  px: 3,
                  minHeight: 44,
                  borderRadius: "33px",
                  bgcolor: "secondary.50",
                  color: "primary.900",
                  textTransform: "none",
                  fontWeight: 800,
                  fontSize: 15,
                  boxShadow: "inset 0px 0px 3px rgba(142, 142, 159, 0.5)",
                  "&:hover": { bgcolor: "secondary.100" },
                }}
              >
                Cancelar
              </Button>
              <Button
                type="button"
                variant="contained"
                disabled={loading}
                onClick={onConfirm}
                startIcon={
                  loading ? (
                    <CircularProgress size={15} color="inherit" />
                  ) : (
                    <DeleteOutlineIcon sx={{ fontSize: 18 }} />
                  )
                }
                sx={{
                  px: 3,
                  minHeight: 44,
                  borderRadius: "33px",
                  bgcolor: "secondary.500",
                  color: "logoblanco",
                  textTransform: "none",
                  fontSize: 15,
                  fontWeight: 800,
                  boxShadow: "0px 8px 20px rgba(76, 72, 141, 0.24)",
                  "&:hover": { bgcolor: "secondary.600" },
                  "&.Mui-disabled": {
                    bgcolor: "secondary.200",
                    color: "rgba(255,255,255,.7)",
                  },
                }}
              >
                {loading ? "Anulando..." : "Anular"}
              </Button>
            </Stack>
          </Stack>
        </Box>
      </Fade>
    </Dialog>
  );
}
